<div class="my__lead__layout">
  <div
    *ngFor="let item of layoutItems; index as i"
    class="layout__item"
    [class.fluid]="item.fluid"
    (click)="item.isCollapsed() && !isMobile ? toggleState(i) : undefined"
    [@itemExpansion]="!isMobile ? item.state : 'default-mobile'"
    [ngClass]="item.state">
    <ng-container
      [ngTemplateOutlet]="(item?.customHeader?.templateRef || defaultHeader)"
      [ngTemplateOutletContext]="{$implicit: item, index: i}"></ng-container>
    <div class="layout__item__content" [@contentExpansion]="isMobile ? item.state : ''">
      <ng-container *ngTemplateOutlet="item?.content?.templateRef ?? null"></ng-container>
    </div>
  </div>
</div>

<ng-template #defaultHeader let-item let-index="index">
  <header class="layout__item__header" (click)="isMobile ? toggleState(index) : undefined">
    <ng-container *ngTemplateOutlet="item?.customTitle?.templateRef || defaultTitle"></ng-container>
    <button (click)="toggleState(index)" class="toggle__btn">
      {{ ( item.isExpanded() ? 'view_translations.reduce_section' : 'view_translations.enlarge_section') | t }}
    </button>
    <nb-icon [ngClass]="item.state" icon="chevron-down" pack="icomoon" class="chevron"> </nb-icon>
  </header>
  <ng-template #defaultTitle>
    <div class="title">
      <nb-icon icon="{{item?.icon}}" pack="icomoon"></nb-icon>
      <p>{{item?.title | t }}</p>
      <ng-container *ngIf="item?.showButton">
        <app-circle-buttons class="ms-3" [icon]="'plus'" [iconSize]="'13'" [grayIcon]="true" (emitAction)="item?.buttonClick.emit()"> </app-circle-buttons>
      </ng-container>
    </div>
  </ng-template>
</ng-template>
